import React from 'react';
import TableRef from '@/util/TableRef';
import styled from 'styled-components';
import { Margin, applyMargin } from '@trevor/ui-components';
import { ChosenMetric } from '@/components/SummarizeMetrics/subcomponents/ChosenMetric';
import ModalWhere from '@/components/modals/ModalWhere';
import { MetricColumnsDropdownList } from '@/components/SummarizeMetrics/subcomponents/MetricColumnsDropdownList';
import { ModalCustomizeAggregateState } from '@/features/countIf/ModalCustomizeAggregate/modalReducer';
import { ColumnNameInput } from '@/features/countIf/ModalCustomizeAggregate/subcomponents/ColumnNameInput';

export type ModalCustomizeAggregateProps = {
  state: ModalCustomizeAggregateState;
  usedAliases: Record<string, TableRef>;
  userInteraction: F<unknown, F0>;
};

export const ModalCustomizeAggregate: React.FC<
  ModalCustomizeAggregateProps
> = ({ state, usedAliases, userInteraction }) => {
  const deleteMetric = userInteraction({ metricRemoved: true });
  return (
    <div>
      <SectionName $margin="0px 0px 8px">Metric</SectionName>
      {state.aggregateFunction ? (
        <ChosenMetric
          aggregateFunction={state.aggregateFunction}
          aliases={usedAliases}
          onClick={deleteMetric}
          onDelete={deleteMetric}
          showCustomName={false}
        />
      ) : (
        <MetricColumnsDropdownList
          columns={state.columns}
          getTableOrInsightName={state.getTableOrInsightName}
          onSelectMetric={(a) => userInteraction({ aggregateFunction: a })()}
          showCustomizeButton={false}
        />
      )}
      <SectionName $margin="16px 0px 8px">Rename your metric</SectionName>
      <ColumnNameInput
        columnName={state.columnName}
        userInteraction={userInteraction}
        isColumnNameError={state.isColumnNameError}
        disabled={!state.aggregateFunction}
      />
      {state.aggregateFunction && (
        <>
          <SectionName $margin="26px 0px 2px">Add a condition</SectionName>
          <span>
            {state.aggregateFunction.columnName()
              ? `${state.aggregateFunction
                  .aggregateOp()
                  .name()} ${state.aggregateFunction.columnName()?.name()}`
              : 'row count'}{' '}
            only when
          </span>
          <ModalWhere
            state={state}
            columns={state.columns}
            userInteraction={userInteraction}
            usedAliases={usedAliases}
            firstLineLabel={null}
          />
        </>
      )}
    </div>
  );
};

const SectionName = styled.div<{ $margin?: Margin }>`
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  display: block;
  ${applyMargin}
`;
